import React from 'react';
import './Homepage.css';

const Homepage = () => {
  return (
    <div className="homepage">
      <p>
        This is the place where i write things
      </p>
      <div className="section">
      <p>
        "volare sicut tyto noctua , to fly like a nightingale"
      </p>
      </div>
      <div className="section">
      <p>
        Alba Software 2024-Present
      </p>
      </div>
    </div>
  );
};

export default Homepage;
